import request from "@/util/request";

/**
 * 封装get请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, data) {
  //url = url.replace(/^\/service/i, "");
  return request({
    url: url,
    method: "get",
    params: data
  });
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function del(url, data) {
  //url = url.replace(/^\/service/i, "");
  return request({
    url: url,
    method: "delete",
    params: data
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
  //url = url.replace(/^\/service/i, "");
  return request({
    url: url,
    method: "post",
    data: data
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data) {
  //url = url.replace(/^\/service/i, "");
  return request({
    url: url,
    method: "put",
    data: data
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data) {
  //url = url.replace(/^\/service/i, "");
  return request({
    url: url,
    method: "patch",
    data: data
  });
}
